import React, {useEffect, useState} from "react";
import {getShoppers} from "../../api/shopper";
import {Col, Row} from "react-bootstrap";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import ShopperCard from "../../components/shoppers/ShopperCard";

export function Shoppers() {
    const [shoppers, setShoppers] = useState([]);

    const cargarShoppers = () => {
        getShoppers()
            .then(r => {
                console.log("Shoppers response:", r.data);
                const shoppers = r.data.data || r.data;
                const shoppersArray = Array.isArray(shoppers) ? shoppers : [];
                setShoppers(shoppersArray)
            })
            .catch(e => {
                setShoppers([])
                console.error("Error cargando los datos", e)
            })
    }

    useEffect(() => {
        cargarShoppers()
    }, [])

    return (
        <>
            <Breadcrumbs title="Shoppers">
                <Row className="mx-4 mx-md-4 px-md-0">
                    {shoppers.map((shopper, i) =>
                        <Col md={12} lg={12} xl={6} key={i} className="my-4" >
                            <ShopperCard shopperStrapi={shopper} />
                        </Col>
                    )}
                </Row>
            </Breadcrumbs>
        </>

    );
}

export default Shoppers
